import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRADES_QUERY_KEY } from "./useTrades";

type TradeResponse = components["schemas"]["TradeResponse"];

export type DeleteTradeLegVariables = {
  tradeId: string;
  legId: string;
};

export function useDeleteTradeLeg() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<TradeResponse, Error, DeleteTradeLegVariables>({
    mutationFn: async ({ tradeId, legId }) => {
      const { data, error } = await client.DELETE("/api/trades/{trade_id}/legs/{leg_id}", {
        params: { path: { trade_id: tradeId, leg_id: legId } },
      });
      if (error !== undefined) {
        throw new Error(`Failed to delete leg ${legId} from trade ${tradeId}`);
      }
      return data;
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: TRADES_QUERY_KEY });
      void queryClient.invalidateQueries({
        queryKey: [...TRADES_QUERY_KEY, "detail", variables.tradeId],
      });
    },
  });
}
